// extracted by mini-css-extract-plugin
module.exports = {"restDayMessage":"style-module__restDayMessage___3gavJ","content":"style-module__content___IwOdP"};